import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";

const InfoPopoverButton = ({ description, id, title }) => {
  if (!description) return null;

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      rootClose
      overlay={
        <Popover id={`${id}-info-popover`}>
          <Popover.Content>{description}</Popover.Content>
        </Popover>
      }
    >
      <Button
        type="button"
        variant="link"
        className="p-0 ml-2 text-info"
        aria-label={`Informationen zu ${title}`}
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </Button>
    </OverlayTrigger>
  );
};

export default InfoPopoverButton;
